/* eslint-disable @typescript-eslint/no-explicit-any */
import MainTable from "../GenericComponents/MainTable";
import { Vocabulary } from "../../Utils/Vocabulary";
import { useState } from "react";
import styles from "../../Styles/dashboard.module.css";
import ManualCostPage from "./ManualCostPage";
import { urlEnum } from "../../Utils/UrlEnum";
import { CustomerModel } from "../../Utils/Models";

export default function ManualCosts() {
  const [open, setOpen] = useState<boolean>();
  const [item, setItem] = useState<any>();
  const [shouldUpdate, setShouldUpdate] = useState(false);

  function handleEdit(item: any) {
    setOpen(!open);
    setItem(item);
    setShouldUpdate(!shouldUpdate);
  }
  const costsHeader = [
    {
      label: Vocabulary.type,
      name: "type",
      options: { sort: false },
    },
    {
      label: Vocabulary.date,
      name: "date",
      options: {
        sort: false,
        customBodyRender: (value: Date) => {
          return <>{value}</>;
        },
      },
    },
    {
      label: Vocabulary.description,
      name: "description",
      options: { sort: false },
    },
    {
      label: Vocabulary.customer,
      name: "customer",
      options: {
        sort: false,
        customBodyRender: (value: CustomerModel) => {
          return <>{value.name}</>;
        },
      },
    },
    {
      label: Vocabulary.vat,
      name: "vat",
      options: { sort: false },
    },
    {
      label: Vocabulary.vendor,
      name: "vendor",
      options: {
        sort: false,
        customBodyRender: (value: CustomerModel) => {
          return <>{value.name}</>;
        },
      },
    },
    {
      label: Vocabulary.documentType,
      name: "documentType",
      options: { sort: false },
    },
    {
      label: Vocabulary.number,
      name: "number",
      options: { sort: false },
    },
  ];
  return (
    <div className={styles.mainContainerUser}>
      <MainTable
        urlEnumApi={urlEnum.costs}
        header={costsHeader}
        tableTitle={Vocabulary.manualList}
        handleEdit={handleEdit}
        shouldUpdate={shouldUpdate}
      />
      {open && (
        <ManualCostPage
          item={item}
          title={Vocabulary.manual}
          open={open}
          onClose={() => {
            setOpen(!open);
          }}
        />
      )}
    </div>
  );
}
